module.exports = __webpack_public_path__ + "static/img/newsdefault.1b04444d.jpg";